module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB1SURBVEhL7ZVbCoAwDAR7O8X7n0A9R2oiIxRDQYOCjw4E2uwmS7+avoWIDFpzDmKzWj3rPCpOeMPojpF1HjyZqwM5rLeAvwbQWnsc3XmDVgu4OKAEOay3gAcE3P4f2G9kBrynsVmtjnV18NefugP7Yf+bSGkBqKLRZoNPwiUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-wardrobe/light/24.png
// module id = 2544
// module chunks = 2